import React from "react";
import { formatAmount } from "../../../OperationsJournal/mock/operationsJournalMock";
import { formatPercent } from "../../utils/allocationBase";
import "./AllocationDetails.css";

/** Сводка «подпись — значение» */
export const SummaryList = ({ rows }) => (
  <dl className="al-summary">
    {rows.map((row) => (
      <div key={row.label} className="al-summary__row">
        <dt>{row.label}</dt>
        <dd className={row.accent ? "is-accent" : undefined}>{row.value}</dd>
      </div>
    ))}
  </dl>
);

const ProjectCell = ({ project }) => (
  <div className="al-project">
    <span className="al-project__code">{project.code}</span>
    <span className="al-project__name">{project.name}</span>
  </div>
);

/** Итоговое распределение по проектам: доля и сумма */
export const AllocationTable = ({ title, rows }) => (
  <div className="al-block">
    {title && <div className="al-block__title">{title}</div>}
    <div className="oj-table-scroll">
      <table className="oj-table al-block__table">
        <thead>
          <tr>
            <th>Проект</th>
            <th className="oj-cell--num">Доля</th>
            <th className="oj-cell--num">Сумма (₸)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.project.id}>
              <td>
                <ProjectCell project={row.project} />
              </td>
              <td className="oj-cell--num">{formatPercent(row.share)}</td>
              <td className="oj-cell--num oj-cell--amount">{formatAmount(row.amount)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td>Итого</td>
            <td className="oj-cell--num">
              {formatPercent(rows.reduce((sum, row) => sum + row.share, 0))}
            </td>
            <td className="oj-cell--num oj-cell--amount">
              {formatAmount(rows.reduce((sum, row) => sum + row.amount, 0))}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
);

/** Управленческие операции, сформированные распределением */
export const EntriesTable = ({ entries }) => (
  <div className="al-block">
    <div className="al-block__title">Созданные операции · {entries.length}</div>
    <div className="oj-table-scroll">
      <table className="oj-table al-block__table">
        <thead>
          <tr>
            <th>Документ</th>
            <th>Исходная операция</th>
            <th>Проект</th>
            <th className="oj-cell--num">Доля</th>
            <th className="oj-cell--num">Сумма (₸)</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.id}>
              <td className="al-block__doc">{entry.document}</td>
              <td>
                <div className="al-project">
                  <span>{entry.sourceDocument}</span>
                  <span className="al-project__name">{entry.sourceDate}</span>
                </div>
              </td>
              <td>
                <ProjectCell project={entry.project} />
              </td>
              <td className="oj-cell--num">{formatPercent(entry.share)}</td>
              <td className="oj-cell--num oj-cell--amount">{formatAmount(entry.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export const getRecordSummary = (record) => [
  { label: "ID", value: record.document },
  { label: "Дата запуска", value: record.launchedAt },
  { label: "Пользователь", value: record.author },
  { label: "Период", value: record.period },
  { label: "База", value: record.baseLabel },
  { label: "Исходных операций", value: record.operationsCount },
  { label: "Получателей", value: record.recipientsCount },
  { label: "Сумма", value: formatAmount(record.total), accent: true },
];

/** Полная карточка проведённого распределения */
function AllocationDetails({ record }) {
  return (
    <div className="al-details">
      <SummaryList rows={getRecordSummary(record)} />
      <AllocationTable title="Распределение по проектам" rows={record.rows} />
      <EntriesTable entries={record.entries} />
    </div>
  );
}

export default AllocationDetails;
